import { useState, useEffect } from 'react';
import { IonModal, IonButton, IonIcon, IonText, IonImg } from '@ionic/react';
import { Accordion, AccordionSection } from 'react-rainbow-components';
import { close } from 'ionicons/icons';
import { Storage } from '@capacitor/storage';
import { Constants } from '../../../defines/Constants';
import axios from 'axios';
import Loading from '../../Loading';
import warningSign from '../../../assets/images/warning.svg';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
    const pageApi = Constants.api.page;
    const [showTermsAndConditions, setShowTermsAndConditions] = useState(false);
    const [pageData, setPageData] = useState(null) as any;
    const [loading, setLoading] = useState(false);
    const [config, setConfig] = useState(null) as any;
    const getConfig = async () => {
        const { value } = await Storage.get({ key: 'config' });
        if (value) {
            const objectValue = JSON.parse(value);
            setConfig(objectValue);
        } else {
            setConfig({});
        }
    }
    useEffect(() => {
        getConfig();
    }, [showTermsAndConditions]);
    useEffect(() => {
        const getPage = async () => {
            setLoading(true);
            try {
                const results = await axios.post(pageApi, { id: config.tos_page_id }, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                        "Accept": "application/json"
                    }
                });
                if (results.status === 200) {
                    setPageData(results.data.page_items[0]);
                    setLoading(false);
                }
            } catch (error: any) {
                console.log(error);
            }
        }
        if (config !== null) {
            getPage();
        }
    }, [config, pageApi]);
    return (
        <>
            <IonModal isOpen={showTermsAndConditions} mode="ios" cssClass="terms-and-conditions-modal">
                {!loading ?
                    pageData !== null ?
                        <div className="terms-and-conditions-modal-body">
                            <h3 className="terms-and-conditions-modal-title">
                                {pageData.title}
                                <IonIcon icon={close} onClick={() => setShowTermsAndConditions(false)} />
                            </h3>
                            <div className="terms-and-conditions-modal-items">
                                <Accordion className="terms-and-conditions-accordion">
                                    {pageData.accordions.map((item: any, index: number) =>
                                        <AccordionSection label={item.title} key={"index" + index}>
                                            <div dangerouslySetInnerHTML={{ __html: item.text }}></div>
                                        </AccordionSection>
                                    )}
                                </Accordion>
                            </div>
                        </div>
                        :
                        <div className="box-error">
                            <IonImg src={warningSign} />
                            <p>اطلاعاتی یافت نشد!</p>
                        </div>
                    :
                    <Loading />
                }
                <IonButton color="warning" onClick={() => setShowTermsAndConditions(false)} className="terms-and-conditions-modal-close-btn">بستن</IonButton>
            </IonModal>
            <IonText color="primary" onClick={() => setShowTermsAndConditions(true)}>شرایط و ضوابط</IonText>
        </>
    );
};
export default TermsAndConditions;